import { useApolloClient } from '@apollo/client';
import { Grid } from '@mui/material';

import { useFormikContext } from 'formik';
import { pick } from 'lodash';

import USER_QUERY from 'gql/queries/currentUser.gql';

import { ArticleItem } from 'app/components/RichList/items/ArticleItem';

import { MailSendDisabledCard } from './MailSendDisabledCard';
import { PushNotificationCard } from './PushNotificationCard';

export default function Preview() {
  const client = useApolloClient();
  const data = client.readQuery({ query: USER_QUERY });
  const { values }: any = useFormikContext();

  const article = {
    ...values,
    author: pick(data.currentUser, ['id', 'firstName', 'lastName', 'email'])
  };

  return (
    <Grid container gap={2}>
      {/* Only show this when you create an Article */}
      {!article.id && <MailSendDisabledCard />}
      <PushNotificationCard />
      <ArticleItem article={article} noOpen />
    </Grid>
  );
}
